<template>
  <div class="applyCredit">
    <Row class="describe" type="flex" justify="end">
      <Col span="12" class="desc-l">
        <div class="desc">
          <h3>{{$t('other.w114')}}</h3>
          <p class="tip">
            <i></i>
            <span>{{$t('label.w135')}}</span>
          </p>
          <ul>
            <li>{{$t('other.w115')}}</li>
            <li>{{$t('other.w116')}}</li>
          </ul>
        </div>
      </Col>
      <Col span="12" class="bg">
        <div class="img-bg"></div>
      </Col>
    </Row>
    <div class="textarea" v-if="!result">
      <div class="top">
        <span>{{$t('label.w196')}}</span>
        <span>
          <span class="text-primary">{{dnlist.length}}</span>/500
        </span>
      </div>
      <div class="input-area">
        <Input
          type="textarea"
          class="scrollbar"
          v-model="dnstr"
          :placeholder="$t('pl.p10')"
          
          @on-blur="check"
        />
      </div>
      <!-- @on-enter="check" -->
      <div class="agree">
        <Checkbox v-model="agree">{{$t('other.w63')}} <a href="javascript:;" @click="protocolShow">{{$t('other.w113')}}</a></Checkbox>
      </div>
      <div class="confirmbtn">
        <Button type="primary" :disabled="!agree||!dnlist.length" @click="submit" :loading="btnLoading">{{$t('btn.b16')}}</Button>
      </div>
    </div>
    <div class="textarea" v-else>
      <div class="top">
        <span>{{$t('label.w196')}}</span>
        <span class="text-primary">{{result.Success}}{{$t('msg.m13')}}，{{result.Fail}}{{$t('msg.m14')}}</span>
      </div>
      <div class="input-area">
        <div class="result scrollbar">
          <!-- <div
            class="item"
            :class="{warning:result.ExistPledge.indexOf(v)>-1,error:result.ErrorPledge.indexOf(v)>-1}"
            v-for="(v,i) in dnlist"
            :key="i"
          >
            {{v}}
            <span class="t" v-if="result.ExistPledge.indexOf(v)>-1">
              <Icon size="16" type="md-alert"/>已存在
            </span>
            <span class="t" v-if="result.ErrorPledge.indexOf(v)>-1">
              <Icon size="16" type="md-close-circle"/>提交失败
            </span>
          </div> -->
          <div
            class="item warning"
            v-for="(v,i) in result.ExistPledge"
            :key="'w'+i"
          >
            {{v}}
            <span class="t">
              <Icon size="16" type="md-alert"/>{{$t('msg.m11')}}
            </span>
          </div>
          <div
            class="item error"
            v-for="(u,z) in result.ErrorPledge"
            :key="'e'+z"
          >
            {{u}}
            <span class="t">
              <Icon size="16" type="md-close-circle"/>{{$t('msg.m12')}}
            </span>
          </div>
          <div
            class="item"
            v-for="(g, h ) in result.SuccessPledge"
            :key="h"
          >
          {{g}}
          </div>
        </div>
      </div>
      <div class="btn">
        <Button type="primary" @click="()=>{ result=null , dnstr='' , dnlist=[] ,agree=false}" :style="{marginRight:'20px'}">{{$t('btn.b14')}}</Button>
        <Button type="primary" @click="$router.replace({name:'domainManage'})">{{$t('btn.b15')}}</Button>
      </div>
    </div>
    <Protocol ref="Protocol" @yes="agree=true" @no="agree=false"/>
  </div>
</template>

<script>
import Protocol from "@/components/protocolModal"
import Exp from "@/libs/Exp"
export default {
  components: { Protocol},
  data() {
    return {
      dnstr: "",
      agree: false,
      dnlist: [],
      result: null,
      btnLoading:false
    };
  },
  methods: {
    async submit() {
      this.btnLoading = true
      if (!this.dnlist.length) return this.$Message.error(this.$t('msg.m64'));
      if (!this.dnlist.length > 500)
        return this.$Message.error(this.$t('msg.m65'));
      if (!this.agree)
        return this.$Message.error(this.$t('msg.m63'));
      let res = await this.$axios.post("/Member/RZJPledge/ApplyCredit", {
        pledgeNames: this.dnlist.join(",")
      });
      this.btnLoading = false
      if(res.err) return res.throw();
      if (!res.err) {
        this.result = res;
      }
    },
    check() {
      if (this.dnstr == "") return (this.dnlist = []);
      let arr = this.dnstr
        .trim()
        .replace(/\n/g, ",")
        .replace(/\s/g, "")
        .replace(/\,+/g, "\n");
      this.dnlist = [...new Set(arr.split("\n"))]
      .filter(v=>Exp.domainName.test(v))
      this.dnstr = this.dnlist.join("\n") + "\n";
    },
    protocolShow(){
      this.$refs.Protocol.type=[6]
      this.$refs.Protocol.modal=true
    },
  },
  mounted(){
    if(this.safe.IdCardVerified===false){
      this.$Message.error(this.$t('msg.m66'))
      this.$router.push({name:'security'})
    }
  },
  computed:{
    safe(){
      return this.$store.state.user.safe
    }
  }
};
</script>

<style lang="less" scoped>
.applyCredit {
  .describe {
    background: url("../../assets/assetcenter/public_quotes.png") no-repeat;
    background-size: 78px 74px;
    background-position: 50px 160px;
    .desc-l {
      margin-top: 30px;
      width: 521px;
      .desc {
        h3 {
          width: 521px;
          font-size: 24px;
          font-weight: 500;
          margin-bottom: 30px;
          color: rgba(51, 51, 51, 1);
          letter-spacing: 1px;
        }
        .tip {
          font-size: 14px;
          font-weight: 500;
          color: rgba(94, 143, 252, 1);
          margin-bottom: 30px;
          span {
            margin-left: 5px;
          }
          i {
            display: inline-block;
            background: url("../../assets/assetcenter/public_hint.png")
              no-repeat;
            width: 14px;
            height: 13px;
            background-size: cover;
          }
        }
        ul {
          margin-left: 15px;
        }
        ul > li {
          width: 439px;
          font-size: 14px;
          color: rgba(51, 51, 51, 1);
          margin-bottom: 20px;
          letter-spacing: 1;
          list-style: decimal;
        }
      }
    }
    .bg {
      position: relative;
      .img-bg {
        position: absolute;
        left: 80px;
        top: 0;
        width: 414px;
        height: 350px;
        background: url("../../assets/assetcenter/credit_img.png") no-repeat;
        background-size: cover;
      }
    }
  }
  .textarea {
    margin-top: 50px;
    width: 1200px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .top {
      width: 460px;
      display: flex;
      justify-content: space-between;
      margin-bottom: 5px;
    }
    .input-area {
       width: 460px;
      .ivu-input-wrapper {
        /deep/.ivu-input {
          resize:none;
          height: 400px;
          line-height: 40px;
          /*滚动条整体*/
        &::-webkit-scrollbar {
          /*滚动条整体样式*/
          width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
        }
        &::-webkit-scrollbar-thumb {
          /*滚动条里面小方块*/
          border-radius: 4px;
          background-color: #5e8ffc;
        }
        &::-webkit-scrollbar-track {
          /*滚动条里面轨道*/
          -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
          background: #d7d7d9;
          border-radius: 4px;
        }
        }
      }
    }
    .agree {
      width: 460px;
      margin: 20px 0 30px;
      display: flex;
      justify-content: flex-start;
      .ivu-checkbox-wrapper {
        margin-right: 0;
        color: rgba(123, 123, 124, 1);
        font-size: 14px;
      }
      span {
        color: #5e8ffc;
        cursor: pointer;
      }
    }
    .confirmbtn {
      .ivu-btn {
        width: 360px;
        height: 50px;
        background: linear-gradient(
          90deg,
          rgba(129, 169, 250, 1) 0%,
          rgba(74, 112, 242, 1) 100%
        );
        border-radius: 25px;
      }
    }
    .btn {
      display: flex;
      justify-content: flex-end;
      width: 460px;
      margin-top: 30px;
      .ivu-btn {
        border-radius: 20px;
      }
    }
  }
}
.result {
  width: 460px;
  height: 400px;
  border-radius: 8px;
  padding: 4px 0;
  background: #f2f4f9;
  overflow: auto;
  .item {
    height: 40px;
    padding: 0 10px;
    border: solid 1px #f2f4f9;
    line-height: 38px;
    position: relative;
    .t {
      display: none;
      position: absolute;
      right: 12px;
      top: 0;
    }
    &.warning {
      border-color: #ffe58f;
      background: #fffbe6;
      color: #faad14;
      .t {
        display: block;
      }
    }
    &.error {
      border-color: #ffa39e;
      background: #fff1f0;
      color: #f5222d;
      .t {
        display: block;
      }
    }
  }
}
</style>


